import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import { alpha } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { NavLink, Outlet } from "react-router-dom";
import { routePaths } from "../routePaths";
import { useThemeMode } from "../contexts/ThemeModeContext";

const DRAWER_WIDTH = 260;

const navItems: { label: string; to: string; end?: boolean }[] = [
  { label: "Dashboard", to: routePaths.dashboard, end: true },
  { label: "DSApps", to: routePaths.dsApps },
  { label: "Templates", to: routePaths.templates },
  { label: "Third Party Contracts", to: routePaths.thirdPartyContracts },
  { label: "Deployments", to: routePaths.deployments },
];

export default function AppShell() {
  const { mode, toggleMode } = useThemeMode();

  const drawer = (
    <Box sx={{ overflow: "auto", pt: 1 }}>
      <List dense disablePadding>
        {navItems.map((item) => (
          <ListItem key={item.to} disablePadding>
            <ListItemButton
              component={NavLink}
              to={item.to}
              end={item.end}
              sx={{
                "&.active": {
                  bgcolor: (theme) =>
                    alpha(theme.palette.primary.main, 0.14),
                  borderRight: 2,
                  borderColor: "primary.main",
                },
              }}
            >
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  sx: {
                    fontSize: "1.125rem",
                    fontWeight: 500,
                    color: "brand.main",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: `calc(100% - ${DRAWER_WIDTH}px)` },
          ml: { sm: `${DRAWER_WIDTH}px` },
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            DSApps Deployments Management
          </Typography>
          <IconButton
            color="inherit"
            onClick={toggleMode}
            aria-label="toggle light or dark mode"
          >
            {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: DRAWER_WIDTH }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="permanent"
          open
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: DRAWER_WIDTH,
              borderRight: 1,
              borderColor: "divider",
            },
          }}
        >
          <Toolbar />
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${DRAWER_WIDTH}px)` },
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
